/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryviews1Inputs */

const en_summaryviews1 = /** @type {(inputs: Summaryviews1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Views`)
};

const de_summaryviews1 = /** @type {(inputs: Summaryviews1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe`)
};

/**
* | output |
* | --- |
* | "Views" |
*
* @param {Summaryviews1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryviews1 = /** @type {((inputs?: Summaryviews1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryviews1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryviews1(inputs)
	return de_summaryviews1(inputs)
});
export { summaryviews1 as "summaryViews" }